import React from 'react';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import get from "lodash/get";

const resolve = (row, field) => (field ? get(row, field) : null);

const SimpleTable = ({ title, columns = [], data = [], options = {} }) => {
    const rows = data || [];
    return (
        <div>
            {title && <Typography variant="subtitle1" gutterBottom>{title}</Typography>}
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {columns.map(col => (
                            <TableCell
                                key={col.field || col.title}
                                align={col.type === "numeric" ? "right" : "left"}
                            >
                                {col.title}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, i) => (
                        <TableRow key={i}>
                            {columns.map(col => (
                                <TableCell
                                    key={col.field || col.title}
                                    align={col.type === "numeric" ? "right" : "left"}
                                >
                                    {resolve(row, col.field)}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default SimpleTable;
